import { useRef, useState } from 'react';

import PropTypes from 'prop-types';

import TextInput from '#globalComponents/Forms/TextInput';

const RenameInput = ({ initialValue, onSave, onDone }) => {
	const [value, setValue] = useState(initialValue);
	const [isSaving, setIsSaving] = useState(false);
	// Enter and the blur that follows (input gets disabled/unmounted) must not save twice.
	const isSettledRef = useRef(false);

	const finish = () => {
		isSettledRef.current = true;
		onDone();
	};

	const save = async () => {
		if (isSettledRef.current || isSaving) return;
		const name = value.trim();
		if (!name || name === initialValue) {
			finish();
			return;
		}
		setIsSaving(true);
		try {
			await onSave(name);
			finish();
		} catch {
			// The global MutationCache already shows the toast; keep the input open for a retry.
			setIsSaving(false);
		}
	};

	return (
		<TextInput
			value={value}
			onChange={(e) => setValue(e.target.value)}
			onClick={(e) => e.stopPropagation()}
			onKeyDown={(e) => {
				if (e.key === 'Enter') save();
				if (e.key === 'Escape') finish();
			}}
			onBlur={save}
			disabled={isSaving}
			autoFocus
			maxLength={100}
			aria-label="Neuer Name"
			className="h-8"
		/>
	);
};

RenameInput.propTypes = {
	initialValue: PropTypes.string.isRequired,
	onSave: PropTypes.func.isRequired,
	onDone: PropTypes.func.isRequired,
};

const CollectionItemTitle = ({ title, isRenaming, onRename, onRenameEnd }) =>
	isRenaming ? (
		<RenameInput initialValue={title} onSave={onRename} onDone={onRenameEnd} />
	) : (
		<h3 className="truncate text-md-bold text-text" title={title}>
			{title}
		</h3>
	);

CollectionItemTitle.propTypes = {
	title: PropTypes.string.isRequired,
	isRenaming: PropTypes.bool,
	onRename: PropTypes.func,
	onRenameEnd: PropTypes.func.isRequired,
};

export default CollectionItemTitle;
